import { apiServiceClient } from '../frameworkClient';

const taasServiceClient = apiServiceClient(
  process.env.REACT_APP_TAAS_URL || 'framework/TAASPortalService',
);

const endpoints = {
  acceptAlternativeFunder: 'acceptAlternativeFunder',
  addResellerContact: 'addResellerContact',
  addResellerLogo: 'addResellerLogo',
  convertToSubscription: 'convertToSubscription',
  createQuote: 'createQuote',
  createQuoteFromSubscription: 'createQuoteFromSubscription',
  declineAlternativeFunders: 'declineAlternativeFunders',
  deleteSubscription: 'deleteSubscription',
  exportPDF: 'exportPDF',
  getCompanyAddress: 'getCompanyAddress',
  getDistributors: 'getDistributors',
  getDocument: 'getDocument',
  getQuote: 'getQuote',
  getResellerContacts: 'getResellerContacts',
  getResellerLogo: 'getResellerLogo',
  getSubscription: 'getSubscription',
  getSubscriptionContacts: 'getSubscriptionContacts',
  getSubscriptions: 'getSubscriptions',
  login: 'login',
  logout: 'logout',
  reAllocateQuote: 'reAllocateQuote',
  removeResellerContact: 'removeResellerContact',
  removeResellerLogo: 'removeResellerLogo',
  searchCustomer: 'searchCustomer',
  searchProduct: 'searchProduct',
  sendDocument: 'sendDocument',
  updateCompanyAddress: 'updateCompanyAddress',
  updateQuote: 'updateQuote',
  updateResellerContact: 'updateResellerContact',
  updateSubscriptionDetails: 'updateSubscriptionDetails',
};

export const acceptAlternativeFunder = async (
  { orderUUID, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.acceptAlternativeFunder,
    { orderUUID, sessionID },
    options,
  );

export const addResellerContact = async (
  {
    contactIndex,
    contactType,
    emailAddress,
    name,
    position,
    resellerSID,
    sendEmailNotifications,
    telephoneNumber,
    useForDocuments,
    sessionID,
  },
  options,
) =>
  taasServiceClient(
    endpoints.addResellerContact,
    {
      contactIndex,
      contactType,
      emailAddress,
      name,
      position,
      resellerSID,
      sendEmailNotifications,
      telephoneNumber,
      useForDocuments,
      sessionID,
    },
    options,
  );

export const addResellerLogo = async (
  { base64Img, fileName, resellerSID, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.addResellerLogo,
    {
      base64Img,
      fileName,
      resellerSID,
      sessionID,
    },
    options,
  );

export const convertToSubscription = async ({ uuid, sessionID }, options) =>
  taasServiceClient(
    endpoints.convertToSubscription,
    {
      uuid,
      sessionID,
    },
    options,
  );

export const createQuote = async (
  { distributorSID, resellerSID, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.createQuote,
    {
      distributorSID,
      resellerSID,
      sessionID,
    },
    options,
  );

export const createQuoteFromSubscription = async (
  { uuid, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.createQuoteFromSubscription,
    {
      uuid,
      sessionID,
    },
    options,
  );

export const declineAlternativeFunders = async ({ uuid, sessionID }, options) =>
  taasServiceClient(
    endpoints.declineAlternativeFunders,
    { uuid, sessionID },
    options,
  );

export const deleteSubscription = async (
  { reason, uuid, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.deleteSubscription,
    {
      reason,
      uuid,
      sessionID,
    },
    options,
  );

export const exportPDF = async (
  { entity, filters, format = 'PDF', sessionID },
  options,
) =>
  taasServiceClient(
    'export',
    {
      entity,
      filters,
      format,
      sessionID,
    },
    options,
  );

export const getCompanyAddress = async ({ resellerSID, sessionID }, options) =>
  taasServiceClient(
    endpoints.getCompanyAddress,
    {
      resellerSID,
      sessionID,
    },
    options,
  );

export const getDistributors = async ({ sessionID }, options) =>
  taasServiceClient(endpoints.getDistributors, { sessionID }, options);

export const getDocument = async ({ entity, filters, sessionID }, options) =>
  taasServiceClient(
    endpoints.getDocument,
    { entity, filters, sessionID },
    options,
  );

export const getQuote = async ({ uuid, sessionID }, options) =>
  taasServiceClient(
    endpoints.getQuote,
    {
      uuid,
      sessionID,
    },
    options,
  );

export const getResellerContacts = async (
  { resellerSID, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.getResellerContacts,
    {
      resellerSID,
      sessionID,
    },
    options,
  );

export const getResellerLogo = async ({ resellerSID, sessionID }, options) =>
  taasServiceClient(
    endpoints.getResellerLogo,
    {
      resellerSID,
      sessionID,
    },
    options,
  );

export const getSubscription = async ({ uuid, sessionID }, options) =>
  taasServiceClient(
    endpoints.getSubscription,
    {
      uuid,
      sessionID,
    },
    options,
  );

export const getSubscriptionContacts = async (
  { uuid, documentType, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.getSubscriptionContacts,
    {
      uuid,
      documentType,
      sessionID,
    },
    options,
  );

export const getSubscriptions = async (
  { count, distributorSIDs, page, resellerSIDs, searchText, states, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.getSubscriptions,
    {
      count,
      distributorSIDs,
      page,
      resellerSIDs,
      searchText,
      states,
      sessionID,
    },
    options,
  );

export const login = async ({ login, password, token }, options) =>
  taasServiceClient(
    endpoints.login,
    {
      login,
      password,
      token,
    },
    options,
  );

export const logout = async ({ sessionID }, options) =>
  taasServiceClient(endpoints.logout, { sessionID }, options);

export const reAllocateQuote = async (
  { uuid, resellerSID, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.reAllocateQuote,
    { uuid, resellerSID, sessionID },
    options,
  );

export const removeResellerContact = async (
  { resellerSID, uuid, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.removeResellerContact,
    {
      resellerSID,
      uuid,
      sessionID,
    },
    options,
  );

export const removeResellerLogo = async ({ resellerSID, sessionID }, options) =>
  taasServiceClient(
    endpoints.removeResellerLogo,
    {
      resellerSID,
      sessionID,
    },
    options,
  );

export const searchCustomer = async (
  { countryCode, isSchool, searchString, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.searchCustomer,
    {
      countryCode,
      isSchool,
      searchString,
      sessionID,
    },
    options,
  );

export const searchProduct = async (
  { page, searchText, size, uuid, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.searchProduct,
    {
      page,
      searchText,
      size,
      uuid,
      sessionID,
    },
    options,
  );

export const sendDocument = async (
  { documentType, languageCode, signatories, uuid, signatureType, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.sendDocument,
    {
      documentType,
      languageCode,
      signatories,
      uuid,
      signatureType,
      sessionID,
    },
    options,
  );

export const updateCompanyAddress = async (
  { address, city, county, postalCode, resellerSID, sessionID },
  options,
) =>
  taasServiceClient(
    endpoints.updateCompanyAddress,
    {
      address,
      city,
      county,
      postalCode,
      resellerSID,
      sessionID,
    },
    options,
  );

export const updateQuote = async (
  {
    customer,
    financingType,
    frequency,
    funder,
    items,
    reference,
    term,
    uuid,
    sessionID,
  },
  options,
) =>
  taasServiceClient(
    endpoints.updateQuote,
    {
      customer,
      financingType,
      frequency,
      funder,
      items,
      reference,
      term,
      uuid,
      sessionID,
    },
    options,
  );

export const updateResellerContact = async (
  {
    contactIndex,
    contactType,
    emailAddress,
    name,
    position,
    resellerSID,
    sendEmailNotifications,
    telephoneNumber,
    useForDocuments,
    uuid,
    sessionID,
  },
  options,
) =>
  taasServiceClient(
    endpoints.updateResellerContact,
    {
      contactIndex,
      contactType,
      emailAddress,
      name,
      position,
      resellerSID,
      sendEmailNotifications,
      telephoneNumber,
      useForDocuments,
      uuid,
      sessionID,
    },
    options,
  );

export const updateSubscriptionDetails = async (
  {
    activationDate,
    endDate,
    funderReference,
    sessionID,
    subscriptionEndingDate: endWarningDate,
    subscriptionRenewDate: subscriptionRenewalDate,
    subscriptionState,
    uuid,
  },
  options,
) =>
  taasServiceClient(
    endpoints.updateSubscriptionDetails,
    {
      activationDate,
      endDate,
      endWarningDate,
      funderReference,
      sessionID,
      subscriptionRenewalDate,
      subscriptionState,
      uuid,
    },
    options,
  );

const taasService = {
  endpoints,
  acceptAlternativeFunder,
  addResellerContact,
  addResellerLogo,
  convertToSubscription,
  createQuote,
  createQuoteFromSubscription,
  declineAlternativeFunders,
  deleteSubscription,
  exportPDF,
  getCompanyAddress,
  getDistributors,
  getDocument,
  getQuote,
  getResellerContacts,
  getResellerLogo,
  getSubscription,
  getSubscriptionContacts,
  getSubscriptions,
  login,
  logout,
  reAllocateQuote,
  removeResellerContact,
  removeResellerLogo,
  searchCustomer,
  searchProduct,
  sendDocument,
  updateCompanyAddress,
  updateQuote,
  updateResellerContact,
  updateSubscriptionDetails,
};

export default taasService;
